import { useVideaNotesCoreContext } from '../context/VideaNotesCoreContext';
import { useVideaNotesNoteResultContext } from '../context/VideaNotesNoteResultContext';
import { VideaNotesUIState } from '../types';

import { QuickNotePatientForm } from './QuickNotePatientForm';
import {
  AudioCaptureBody,
  AudioCaptureHeader,
} from './slideOutViews/AudioCaptureView';
import { NoteErrorView } from './slideOutViews/NoteErrorView';
import { NoteGenerationView } from './slideOutViews/NoteGenerationView';
import {
  NoteResultBody,
  NoteResultHeader,
} from './slideOutViews/NoteResultView';

/**
 * Main content area for the VideaNotes sheet.
 * Consumes Core and NoteResult contexts for required state and handlers.
 */
export const VideaNotesMainContent = () => {
  const {
    uiStatus,
    patientName,
    processingError,
    onPatientCreated,
    onCloseSheet,
  } = useVideaNotesCoreContext();

  const { selectedNote } = useVideaNotesNoteResultContext();

  return (
    <div className="vai-relative vai-flex-1 vai-min-h-0 vai-flex vai-flex-col">
      {/* Header row: patient name + controls */}
      <div className="vai-flex vai-pt-1 vai-items-center vai-justify-between vai-w-full">
        <div className="vai-flex vai-flex-col vai-w-1/3">
          <p
            className="vai-text-xl vai-text-black"
            data-testid="patient-name-videa-notes-sheet"
          >
            {patientName}
          </p>
        </div>

        {/* Audio capture header controls (mic selector, template selector) */}
        {uiStatus === VideaNotesUIState.AUDIO_CAPTURE && <AudioCaptureHeader />}

        {/* Note result header controls (note selector only) */}
        {uiStatus === VideaNotesUIState.SUMMARY_RESULT && selectedNote && (
          <NoteResultHeader />
        )}
      </div>

      {/* Patient info form (quick note) */}
      {uiStatus === VideaNotesUIState.PATIENT_INFO && (
        <QuickNotePatientForm
          onPatientCreated={onPatientCreated}
          onCancel={onCloseSheet}
        />
      )}

      {/* Audio capture body (recorder controls) */}
      {uiStatus === VideaNotesUIState.AUDIO_CAPTURE && <AudioCaptureBody />}

      {/* Note generation loading */}
      {uiStatus === VideaNotesUIState.NOTE_GENERATION && <NoteGenerationView />}

      {/* Note result body (editor + action buttons) */}
      {uiStatus === VideaNotesUIState.SUMMARY_RESULT && selectedNote && (
        <NoteResultBody />
      )}

      {/* Error view */}
      {uiStatus === VideaNotesUIState.ERROR && processingError !== undefined && (
        <NoteErrorView error={processingError} onDismiss={onCloseSheet} />
      )}
    </div>
  );
};
